import { compose } from 'recompose';
import { connect } from 'react-redux';

import { selectors as configSelectors } from '../../../../../redux/config';
import intlEquipped from '../../../../../hocs/intlEquipped';

import InfoSection from './InfoSection';

const mapStateToProps = state => ({
    publication: configSelectors.getPublication(state),
});

export default compose(
    connect(mapStateToProps, null),
    intlEquipped
)(InfoSection);
